module.exports = __webpack_public_path__ + "img/sunrise-over-mountains.b9438051.png";